"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/userservice/v1/api";
var config = {
  root: serviceURL,
  user: serviceURL + "/user",
  general: serviceURL + "/general",
  group: serviceURL + "/group",
  authenticate: serviceURL + "/authenticate",
  userAdminPlatform: serviceURL + "/user/admin/platform",
  userAdminPlatformBulk: serviceURL + "/user/bulk/platform",
  userAdminBrand: serviceURL + "/user/admin/brand",
  userAdminReport: serviceURL + "/user/admin/report",
  userAdminContent: serviceURL + "/user/admin/content",
  userAdminApplication: serviceURL + "/user/admin/application",
  userAdminData: serviceURL + "/user/admin/data",
  apiKey: serviceURL + "/api-key",
  role: serviceURL + "/role",
  totp: serviceURL + "/totp",
  info: serviceURL + "/organization/info",
  deviceInfo: serviceURL + "/device",
  masterPassCode: serviceURL + "/general/passcode",
  userProfileInfo: serviceURL + "/user-profile",
  siteSetting: serviceURL + "/setting/site",
  reportSetting: serviceURL + "/setting/report",
  systemAdminUser: serviceURL + "/user/admin",
  userLog: serviceURL + "/log/session",
  crm: serviceURL + "/authenticate/crm"
};
exports.config = config;